"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2635],{

/***/ 92635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_cricket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34044);
/* harmony import */ var constants_newsLetter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31445);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var FooterNewsLetter = function FooterNewsLetter(_ref) {
  var size = _ref.size,
      fromHome = _ref.fromHome;
  var SUCCESS_TEXT = 'Email has been sent. Please check';
  var FAIL_TEXT = "Something went wrong Try again";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('<strong>NOTE:</strong> By entering your email ID, you authorise <a href = "/">thelallantop.com</a> to send newsletters to your email.'),
      bottomText = _useState2[0],
      setBottomText = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isError = _useState3[0],
      setIsError = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      subscribeLoading = _useState4[0],
      setSubscribeLoading = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([true, true]),
      subscribeType = _useState5[0],
      setSubscribeType = _useState5[1];

  var imagePath = fromHome ? "./assets/images/news_letter.png" : "./../../assets/images/news_letter.png";

  var handleSubscribeClick = function handleSubscribeClick() {
    var obj = {
      eventName: fromHome ? 'HP_Newsletter_Subscribe_Widget_Click' : 'AP_Newsletter_Subscribe_Widget_Click',
      pageTitle: fromHome ? "Homepage" : "Article Page"
    };
    (0,constants_cricket__WEBPACK_IMPORTED_MODULE_0__/* .callGaEvent */ .ut)(obj); //if the user hasn't enter email

    if (email == '') {
      setIsError(true);
      setBottomText('Email is required');
      return;
    } //if the user hasn't selected any type


    if (subscribeType[0] == false && subscribeType[1] == false) {
      setIsError(true);
      setBottomText('Please Select atleast one option');
      return;
    }

    var type = [];

    if (subscribeType[0]) {
      type.push('editorial');
    }

    if (subscribeType[1]) {
      type.push('ai');
    }

    setSubscribeLoading(true);
    (0,constants_newsLetter__WEBPACK_IMPORTED_MODULE_1__/* .requestSubscription */ .HH)(email, type).then(function (res) {
      var _res$data, _res$data2;

      setBottomText(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.message ? res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.message : SUCCESS_TEXT);
      setSubscribeLoading(false);
      setIsError(false);
    })["catch"](function (err) {
      setBottomText(err !== null && err !== void 0 && err.data ? err === null || err === void 0 ? void 0 : err.data : FAIL_TEXT);
      setSubscribeLoading(false);
      setIsError(true);
    });
  };

  var handleSubscriptionTypeChange = function handleSubscriptionTypeChange(event, index) {
    var value = event.target.checked;
    var newType = [0, 0];

    if (index == 0) {
      newType[0] = value;
      newType[1] = subscribeType[1];
      var obj = {
        eventName: fromHome ? 'HP_News_Editor_Widget_Click' : 'AP_News_Editor_Widget_Click',
        pageTitle: fromHome ? "Homepage" : 'Article Page'
      };
      (0,constants_cricket__WEBPACK_IMPORTED_MODULE_0__/* .callGaEvent */ .ut)(obj);
    } else {
      newType[0] = subscribeType[0];
      newType[1] = value;
      var _obj = {
        eventName: fromHome ? 'HP_News_AI_Widget_Click' : 'AP_News_AI_Widget_Click',
        pageTitle: fromHome ? "Homepage" : 'Article Page'
      };
      (0,constants_cricket__WEBPACK_IMPORTED_MODULE_0__/* .callGaEvent */ .ut)(_obj);
    }

    setSubscribeType(newType);
  };

  var containerStyle = {
    display: 'flex',
    backgroundColor: '#F8F0E3',
    borderRadius: '8px',
    width: '328px',
    alignItems: 'center'
  };
  var inputStyle = {
    border: 'none',
    outline: 'none',
    padding: '0px 15px',
    backgroundColor: '#F8F0E3',
    fontSize: '14px',
    fontWeight: "40",
    color: '#333'
  };
  var buttonStyle = {
    backgroundColor: '#FFC609',
    border: 'none',
    padding: '10px 20px',
    fontWeight: '400',
    borderRadius: '8px',
    color: '#000',
    cursor: 'pointer',
    fontSize: "12px",
    minWidth: "94px"
  };
  var checkBoxContainer = {
    display: 'flex',
    justifyContent: "space-evenly",
    width: '300px',
    alignItems: 'center'
  };
  return (size === null || size === void 0 ? void 0 : size.width) > 700 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: "container ".concat(fromHome ? 'my-2' : 'my-4'),
    style: {
      height: "164px",
      backgroundColor: "#FBF8F1",
      borderRadius: "10px"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "d-flex align-items-center justify-content-center",
      style: {
        gap: "10%"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: "Subscribe "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: " to Our Newsletter"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        style: containerStyle,
        className: "shadow-sm",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          value: email,
          onChange: function onChange(event) {
            return setEmail(event.target.value);
          },
          type: "email",
          placeholder: "Enter Your Email",
          style: inputStyle,
          className: "form-control-plaintext",
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter") {
              handleSubscribeClick();
            }
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
          onClick: handleSubscribeClick,
          style: buttonStyle,
          className: "ms-2",
          children: subscribeLoading ? '...' : 'SUBSCRIBE'
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        style: {
          width: "147px",
          height: "130px"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
          className: "w-100 h-100",
          src: imagePath
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      style: checkBoxContainer,
      className: "mx-auto",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("label", {
        style: {
          fontWeight: 400,
          fontSize: "12px",
          color: "#4E4E4E"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          checked: subscribeType[0],
          onChange: function onChange(event) {
            return handleSubscriptionTypeChange(event, 0);
          },
          type: "checkbox",
          name: "fruit",
          value: "apple"
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          children: "Editorial Picks"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("label", {
        style: {
          fontWeight: 400,
          fontSize: "12px",
          color: "#4E4E4E"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          checked: subscribeType[1],
          onChange: function onChange(event) {
            return handleSubscriptionTypeChange(event, 1);
          },
          type: "checkbox",
          name: "fruit",
          value: "mango"
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          children: "AI Driven Content"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
      className: "m-0 p-0 text-end me-5",
      dangerouslySetInnerHTML: {
        __html: bottomText
      },
      style: {
        fontWeight: isError ? 600 : 200,
        fontSize: isError ? "13px" : "9px",
        color: isError ? "red" : "#333"
      }
    })]
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: "container my-2 ",
    style: {
      backgroundColor: "#FBF8F1",
      borderRadius: "10px"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "d-flex align-items-center justify-content-center",
      style: {
        gap: "10%"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: "Subscribe "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "m-0 p-0",
          style: {
            fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
            fontWeight: 900,
            fontSize: "25px"
          },
          children: " to our Newsletter"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        style: {
          width: "70px",
          height: "79px"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
          className: "w-100 h-100",
          src: imagePath
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      style: containerStyle,
      className: "shadow-sm mx-auto my-4",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
        value: email,
        onChange: function onChange(event) {
          return setEmail(event.target.value);
        },
        type: "email",
        placeholder: "Enter Your Email",
        style: inputStyle,
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter") {
            handleSubscribeClick();
          }
        },
        className: "form-control-plaintext"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
        onClick: handleSubscribeClick,
        style: buttonStyle,
        className: "ms-2",
        children: subscribeLoading ? '...' : 'SUBSCRIBE'
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      style: checkBoxContainer,
      className: "mx-auto my-2",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("label", {
        style: {
          fontWeight: 400,
          fontSize: "12px",
          color: "#4E4E4E"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          checked: subscribeType[0],
          onChange: function onChange(event) {
            return handleSubscriptionTypeChange(event, 0);
          },
          type: "checkbox",
          name: "fruit",
          value: "apple"
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          children: "Editorial Picks"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("label", {
        style: {
          fontWeight: 400,
          fontSize: "12px",
          color: "#4E4E4E"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          checked: subscribeType[1],
          onChange: function onChange(event) {
            return handleSubscriptionTypeChange(event, 1);
          },
          type: "checkbox",
          name: "fruit",
          value: "mango"
        }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          children: "AI Driven Content"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
      className: "m-0 p-0 text-center",
      dangerouslySetInnerHTML: {
        __html: bottomText
      },
      style: {
        fontWeight: isError ? 600 : 200,
        fontSize: isError ? "13px" : "9px",
        color: isError ? "red" : "#333"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FooterNewsLetter);

/***/ }),

/***/ 31445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ unSubscribe; },
/* harmony export */   "HH": function() { return /* binding */ requestSubscription; },
/* harmony export */   "LF": function() { return /* binding */ showPopupOrNot; },
/* harmony export */   "h9": function() { return /* binding */ confirmSubscription; }
/* harmony export */ });
/* unused harmony export APIS */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9041);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);




var APIS = {
  requestSubscribe: "/newsletter/requestSubscription",
  confirmSubscribe: "/newsletter/confirmSubscription",
  checkSubscriptionStatus: "/newsletter/subscriptionStatus",
  unsubscribe: "/newsletter/unsubscribe"
};
var requestSubscription = function requestSubscription(email) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return new Promise( /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resolve, reject) {
      var url, res, _err$response, _err$response2, _err$response2$data, _err$response3, _err$response3$data;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              url = api_constants__WEBPACK_IMPORTED_MODULE_3__/* .baseUrl */ .FH + APIS['requestSubscribe'];
              _context.next = 4;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, {
                email: email,
                type: type
              });

            case 4:
              res = _context.sent;
              resolve({
                success: true,
                data: res === null || res === void 0 ? void 0 : res.data
              });
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error("Subscription error:", _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response);
              reject({
                success: false,
                data: _context.t0 !== null && _context.t0 !== void 0 && _context.t0.response && _context.t0 !== null && _context.t0 !== void 0 && _context.t0.response && _context.t0 !== null && _context.t0 !== void 0 && (_err$response = _context.t0.response) !== null && _err$response !== void 0 && _err$response.data && _context.t0 !== null && _context.t0 !== void 0 && (_err$response2 = _context.t0.response) !== null && _err$response2 !== void 0 && (_err$response2$data = _err$response2.data) !== null && _err$response2$data !== void 0 && _err$response2$data.message ? _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response3 = _context.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : _err$response3$data.message : _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};
var confirmSubscription = function confirmSubscription(token) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(resolve, reject) {
      var _res$data, url, res;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              url = api_constants__WEBPACK_IMPORTED_MODULE_3__/* .baseUrl */ .FH + APIS['confirmSubscribe'];
              _context2.next = 4;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, {
                token: token
              });

            case 4:
              res = _context2.sent;

              if (res && res !== null && res !== void 0 && res.data && res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.status) {
                resolve({
                  success: true,
                  data: res === null || res === void 0 ? void 0 : res.data
                });
              } else {
                reject({
                  success: false,
                  data: "Something went wrong"
                });
              }

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error("Confirm Subscription error:", _context2.t0);
              reject({
                success: false,
                data: _context2.t0 !== null && _context2.t0 !== void 0 && _context2.t0.message ? _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message : "Something went wrong"
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};
var unSubscribe = function unSubscribe(email) {
  var reasonString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(resolve, reject) {
      var _res$data2, url, res, _err$response4, _err$response5, _err$response5$data, _err$response6, _err$response6$data;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              url = api_constants__WEBPACK_IMPORTED_MODULE_3__/* .baseUrl */ .FH + APIS['unsubscribe'];
              _context3.next = 4;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post(url, {
                email: email,
                unsubscribeReason: reasonString,
                type: type
              });

            case 4:
              res = _context3.sent;

              if (res && res !== null && res !== void 0 && res.data && res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.status) {
                resolve({
                  success: true,
                  data: res === null || res === void 0 ? void 0 : res.data
                });
              } else {
                reject({
                  success: false,
                  data: "Something went wrong"
                });
              }

              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              console.error("Unsubscribe error:", _context3.t0);
              reject({
                success: false,
                data: _context3.t0 !== null && _context3.t0 !== void 0 && _context3.t0.response && _context3.t0 !== null && _context3.t0 !== void 0 && _context3.t0.response && _context3.t0 !== null && _context3.t0 !== void 0 && (_err$response4 = _context3.t0.response) !== null && _err$response4 !== void 0 && _err$response4.data && _context3.t0 !== null && _context3.t0 !== void 0 && (_err$response5 = _context3.t0.response) !== null && _err$response5 !== void 0 && (_err$response5$data = _err$response5.data) !== null && _err$response5$data !== void 0 && _err$response5$data.message ? _context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_err$response6 = _context3.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : _err$response6$data.message : _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
};
var showPopupOrNot = function showPopupOrNot() {
  //show popup only when user or guest has not subscribed yet
  var subscribed = localStorage.getItem('subscribed');

  if (subscribed) {
    //user have subscribed so will not show the popup
    return false;
  } else {
    var lastShowedSubscribe = localStorage.getItem('lastShowedSubscribe');

    if (lastShowedSubscribe) {
      var diff = getDaysDifference(lastShowedSubscribe, Date.now());
      console.log(diff, ' difference in seconds');

      if (diff > 3) {
        //last popup is being showed 3 days before
        return true;
      } else {
        //last popup is being within last 3 days
        return false;
      }
    } //popop is being showed for the first time
    else {
      return true;
    }
  }
};

function getDaysDifference(startTimestamp, endTimestamp) {
  var msInDay = 1000 * 60 * 60 * 24;
  var diffMs = endTimestamp - startTimestamp;
  return Math.floor(diffMs / msInDay);
}

function getSecondsDifference(startTimestampMs, endTimestampMs) {
  return Math.floor((endTimestampMs - startTimestampMs) / 1000);
}

/***/ })

}]);